/**
 * DATACARDS-TEMPLATES — Registry e roteador de cards visuais inline no chat.
 *
 * Backend anexa { type, data, voice_summary } em response.datacard quando
 * a pergunta do user matcha um tipo de DataCard. Aqui escolhemos o
 * subcomponente correspondente.
 *
 * Tipo desconhecido → render null (gracefully ignored).
 */
import ExpenseSummaryCard from "./datacards/ExpenseSummaryCard";
import BalanceOverviewCard from "./datacards/BalanceOverviewCard";
import UpcomingPaymentsCard from "./datacards/UpcomingPaymentsCard";
import TaskOverviewCard from "./datacards/TaskOverviewCard";
import InvestmentOverviewCard from "./datacards/InvestmentOverviewCard";
import SubscriptionSummaryCard from "./datacards/SubscriptionSummaryCard";
// DATACARD-EXPANSAO: 4 cards novos pareando builders backend.
import HabitStreakCard from "./datacards/HabitStreakCard";
import ProjectStatusCard from "./datacards/ProjectStatusCard";
import CategoryBreakdownCard from "./datacards/CategoryBreakdownCard";
import FinancialHealthCard from "./datacards/FinancialHealthCard";

const REGISTRY = {
  expense_summary: ExpenseSummaryCard,
  balance_overview: BalanceOverviewCard,
  upcoming_payments: UpcomingPaymentsCard,
  task_overview: TaskOverviewCard,
  investment_overview: InvestmentOverviewCard,
  subscription_summary: SubscriptionSummaryCard,
  habit_streak: HabitStreakCard,
  project_status: ProjectStatusCard,
  category_breakdown: CategoryBreakdownCard,
  financial_health: FinancialHealthCard,
};

export default function MessageDataCard({ datacard }) {
  if (!datacard?.type) return null;
  const Component = REGISTRY[datacard.type];
  if (!Component) return null;
  return (
    <div className="my-2" data-testid={`datacard-${datacard.type}`}>
      <Component data={datacard.data} />
    </div>
  );
}
